import Vue           from "vue";
import Vuex          from "vuex";
import state         from "./state";
import actions       from "./actions";
import mutations     from "./mutations";
import getters       from "./getters";
import users         from "./modules/users";
import app           from "./modules/app";
import auth          from "./modules/auth";
import menuItems     from "./modules/menu-items";
import notifications from "./modules/notifications";

Vue.use(Vuex);

export const store = new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    modules: {
        users,
        auth,
        app,
        menuItems,
        notifications,
    }
});
